import { all } from 'redux-saga/effects';

// global store
import client from 'src/store/client/sagas';
import view from 'src/store/view/sagas';
import globalAnalytics from 'src/store/analytics/sagas';
import mindboxAnalytics from 'src/store/mindbox/sagas';
import wishlist from 'src/store/wishlist/sagas';
import bannerAppData from 'src/store/appBanners/sagas';
import hotelImagesSaga from 'src/store/hotelImages/saga';

import appBannersSagaWatcher from 'src/store/appBannerStats/saga';
import cashbackSaga from 'src/store/cashback/saga';
import searchSaga from './search';
import hotelsSaga from '../store/hotels/saga';
import mapSaga from '../store/map/sagas';
import filtersSaga from './filters';
import sortingSaga from './sorting';
import analyticsSaga from './analytics';
import emptySearch from '../store/emptySearch/saga';
import priceChart from '../store/priceChart/saga';
import searchView from '../store/view/saga';
import previousFilters from '../../../store/previousFilters/sagas';

function* sagas() {
  yield all([
    client(),
    view(),
    wishlist(),
    globalAnalytics(),
    mindboxAnalytics(),
    bannerAppData(),
    //
    mapSaga(),
    searchSaga(),
    hotelsSaga(),
    hotelImagesSaga(),
    filtersSaga(),
    previousFilters(),
    sortingSaga(),
    analyticsSaga(),
    emptySearch(),
    priceChart(),
    searchView(),
    appBannersSagaWatcher(),
    cashbackSaga(),
  ]);
}

export default sagas;
